import { blockInternal, requiresAuth, requiresTerms, blockEcommerce } from "@/middleware";

const OrdersView = () => import("./OrdersView.vue");
const OrderDetailsView = () => import("./OrderDetailsView.vue");
const OrderConfirmationView = () => import("../orders/OrderConfirmationView.vue");
const AnonymousOrderConfirmationView = () => import("../orders/AnonymousOrderConfirmationView.vue");
const PayNowForm = () => import("@/components/checkout/PayNowForm.vue");
const AnonymousCheckout = () => import("./AnonymousCheckout.vue");

const orderRoutes = [
  {
    path: "/orders",
    name: "OrdersView",
    component: OrdersView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal, blockEcommerce]
    }
  },
  {
    path: "/orders/:id",
    name: "OrderDetails",
    component: OrderDetailsView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal, blockEcommerce]
    }
  },
  {
    path: "/orders/confirmation",
    name: "OrderConfirmation",
    component: OrderConfirmationView,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal, blockEcommerce]
    }
  },
  // Anonymous Order Routes
  {
    path: "/pay-now/confirmation",
    name: "AnonymousOrderConfirmation",
    component: AnonymousOrderConfirmationView,
    props: true
  },
  {
    path: "/pay-now",
    name: "PayNow",
    component: PayNowForm,
    props: true,
    meta: {
      middleware: [blockEcommerce]
    }
  },
  {
    path: "/pay-now/checkout",
    name: "AnonymousCheckout",
    component: AnonymousCheckout,
    props: true,
    meta: {
      middleware: [blockEcommerce]
    }
  }
];

export default orderRoutes;
